import { useAutoExpireCache } from "../middleware";
import { useAppSelector } from "../../../store";

export const RendererFrame = () => {

  useAutoExpireCache();
  const display = useAppSelector(state => state.settings.display);

  return (
    <iframe
      className="absolute opacity-0"
      id="jw-renderer-frame"
      sandbox="allow-scripts allow-same-origin"
      src="/renderer.html"
      style={{ ...display, top: -display.height }}
    ></iframe>
  );
};
